import styled from 'styled-components';

export const Duration = styled.span`
  color: ${({ theme }) => theme.config.card.text.disabled};
`;
